/*eslint-disable eqeqeq */
import Formatter from '../helpers/formatter';
import Validator from '../helpers/validator';

const missions = {
  state: {
    missions: [
      //{ id: 1, name: 'Foo' },
      //{ id: 2, name: 'Bar' }
    ],
    isMissionFiltered: false,
    missionFilters: {
      timeRange: {
        //date_before: 1514764800, the number is unix epoch in seconds
        //date_after: 1514764800, the number is unix epoch in seconds
      },
      status: 'open,verified,completed' //status can be 'open','completed','verified'
    },
    missionListPaginationInfo: {
      pageSize: 10,
      currentPage: 1,
      total: 0
    }
  },

  getters: {
    filterMissionsByKidId: state => id => {
      //Sort missions by 'updated_at', put the most recently updated mission on the top of the list.
      return Formatter.sortData(
        state.missions.filter(mission => mission.user_id == id),
        ['updated_at'],
        ['desc']
      );
    },

    findMissionById: state => id => {
      return state.missions.find(mission => mission.id == id);
    },

    isMissionFiltered: state => () => {
      return state.isMissionFiltered;
    },

    getMissionFilters: state => () => {
      return state.missionFilters;
    },

    getMissionListPaginationInfo: state => () => {
      return state.missionListPaginationInfo;
    }
  },

  mutations: {
    updateMission(state, mission) {
      let index = state.missions.findIndex(item => item.id === mission.id);

      if (index > -1) {
        state.missions.splice(index, 1, mission);
      }
    },

    addMission(state, mission) {
      state.missions.push(mission);
    },

    addMissions(state, missions) {
      //TODO this is naive, we should append instead of outright replacing
      state.missions = missions;
    },

    toggleMissionCompletion(state, id) {
      const complete = state.missions.find(mission => mission.id === id)
        .complete;
      state.missions.find(mission => mission.id === id).complete = !complete;
    },

    rejectMission(state, id) {
      state.missions.find(mission => mission.id === id).complete = false;
    },

    removeMission(state, id) {
      state.missions = state.missions.filter(mission => mission.id !== id);
    },

    extendMission(state, payload) {
      state.missions.find(mission => mission.id === payload.id).due_date =
        payload.due_date;
    },

    restoreMission(state, payload) {
      let mission = state.missions.find(mission => mission.id === payload.id);

      if (!Validator.isEmpty(mission)) {
        mission.due_date = payload.due_date;
        mission.verified = payload.verified;
        mission.complete = payload.complete;
      }
    },

    setIsMissionFiltered(state, payload) {
      state.isMissionFiltered = payload;
    },

    setMissionFilters(state, payload) {
      state.missionFilters = Formatter.extend(state.missionFilters, payload);
    },

    setMissionListPaginationInfo(state, payload) {
      state.missionListPaginationInfo = Formatter.extend(
        state.missionListPaginationInfo,
        payload
      );
    }
  }
};

export default missions;



// WEBPACK FOOTER //
// ./src/store/missions.js